<template>
  <div class="emap-flow-comment">
    <!--根据taskId来判断意见评论区是否显示-->
    <div v-if="!hidden" class="emap-flow-comment-opt">
      <div class="comment-title" :class="{'comment-required': required || needElecseal || needEsignature}" v-if="label">{{label}}</div>
      <div class="emap-flow-comment-item current-comment" 
        :class="[{'hasElecseal':elecseal||esignature, 'radio': (elecseal||esignature) && !multiple}]" 
        v-if="schema != 'default' || (showCurComment && taskId && !isFinishedTask)">
        <template v-if="checkboxOnly && mergeOptions.length === 1 && showInput">
          <Checkbox v-model="approval" :true-value="mergeOptions[0].id" false-value="" :disabled="mergeOptions[0].disabled" @on-change="approvalChange"><span class="option-label">{{mergeOptions[0].name}}</span></Checkbox>
        </template>
        <template v-else>
          <RadioGroup v-model="approval" style="display: block" @on-change="approvalChange" v-if="showInput">
            <Radio v-for="item in mergeOptions" :key="item.id" :label="item.id" :disabled="item.disabled"><span class="option-label">{{item.name}}</span></Radio>
          </RadioGroup>
        </template>
        <div class="ivu-form-item">
          <div class="ivu-form-item-content" style="display: flex;">
            <Dropdown trigger="click" class="dropdown-input" transfer @on-click="chooseComment" placement="bottom-start">
              <Input class="comment-simulator"  :class="[{'comment-input-error': validateError, 'comment-input-readonly': readonly}]" v-if="showInput">
                <div slot="append" class="comment-wrapper">
                  <Input v-model.trim="comment" type="textarea" :placeholder="il8Placeholder" :autosize="true" @on-blur="onBlur" @on-focus="onFocus" class="comment-textarea" :readonly="readonly"/>
                  <div class="comment-toolbar"><span class="comment-sample-save" :class="{'disabled': !comment}" @click="saveSample" v-if="sample && !readonly">{{$LocalH5('saveComment')}}</span></div>
                </div>
              </Input>
              <dropdown-menu slot="list" v-show="showSample && defaultComments.length" v-if="showInput">
                <dropdown-item disabled >{{$LocalH5('commonComment')}}</dropdown-item>
                <dropdown-item v-for="(item, index) in defaultComments" :key="index" :divided="!index" :name="item.NAME"> {{item.NAME}}</dropdown-item>
              </dropdown-menu>
            </Dropdown>
            <template v-if="!getSealLoading">
              <template  v-if="(elecseal || esignature) && signatureType == '3' && hasLoaded && schema === 'default'">
                <div class="emap-flow-comment-elecseal e-signature-wrap">
                  <e-seal ref="eSeal" v-bind="{elecseal,esignature}"></e-seal>
                </div>
              </template>
              <template  v-if="(elecseal || esignature) && signatureType == '4'">
                <!--4：诺安 -->
                <div class="emap-flow-comment-elecseal e-signature-wrap" >
                  <nuo-seal ref="nuoSealComp" :sealConfigData="sealConfigData" :nuo-seal="nuoSeal"></nuo-seal>
                </div>
              </template>
              <template v-else>
                <template v-if="signatureType == '1'">
                  <div class="emap-flow-comment-elecseal"
                    v-if="elecseal||esignature" 
                    :class="elecsealClassArr" 
                    @click="sealSelect"
                    id="pos">
                      <span class="emap-flow-elecseal-label" :class="[{'single': multiple && chapterUrl.length ==1, 'radio': !multiple }]" v-if="multiple?chapterUrl.length < 2:!chapterUrl.length">
                        {{elecseal ? $LocalH5('sealOrSign.addSeal'):$LocalH5('sealOrSign.addSignature')}}
                      </span>
                      <div class="emap-flow-elecseal-imgs"  v-if="chapterUrl.length">
                        <div class="emap-flow-elecseal-img" v-for="(item, index) in chapterUrl" :key="index">
                          <img :src="item" />
                          <div class="img-popup-body" @click="preventEvent" v-if="!readonly">
                            <Button type="text" ghost @click="modifySeal">{{$LocalH5('change')}}</Button>
                            <Button type="text" ghost @click="delSeal(item, index)">{{$LocalH5('delete')}}</Button>
                          </div>
                        </div>
                      </div>
                  </div>
                </template>
                <template v-else-if="signatureType == '2'">
                  <div class="emap-flow-comment-elecseal"
                    v-if="elecseal||esignature" 
                    :class="elecsealClassArr" 
                    id="pos">
                    <!-- 金格选两个章 -->
                    <template v-if="multiple">
                      <span class="emap-flow-elecseal-label" :class="[{'single': kingGridWidArr.length == 1 && curOptPos === kingGridPosArr[1] || kingGridWidArr.length == 1 && !curOptPos, 'single-left': kingGridWidArr.length == 1 && curOptPos === kingGridPosArr[0]}]" v-if="kingGridWidArr.length < 2">{{$LocalH5('sealOrSign.addSeal')}}</span>
                    </template>
                    <template v-else>
                      <span class="emap-flow-elecseal-label radio" v-if="kingGridWidArr.length < 1">{{$LocalH5('sealOrSign.addSeal')}}</span>
                    </template>
                    <div :class="{ ['king-grid-pos-' + (index + 1)]: true, 'radio': !multiple }" v-for="(item, index) in kingGridPosArr" :key="index" :id="item"  @click="sealSelect" ></div>
                  </div>
                </template>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="emap-flow-old-comment" v-if="schema ==='default' && showOldComment && taskId">
      <div class="history-comment-label" @click="handleHistory">
        <span>{{$LocalH5('sealOrSign.viewOther')}}</span><Icon :type="showHistory ? 'ios-arrow-up' : 'ios-arrow-down'" class="history-icon"/>
      </div>
      <div class="history-comment-content" v-show="showHistory">
        <div class="history-comment-empty">
          <Spin size="large" class="history-comment-loading" v-if="historyLoading"></Spin>
          <span v-if="historyEmpty">{{$LocalH5('noData')}}</span>
        </div>
        <div class="emap-flow-comment-item" v-for="(item,key) in flowComments" :key="key">
          <div class="title"><label><span style="margin-right: 4px;">{{item.nodeName}}</span>{{$LocalH5('suggestion')}}：</label></div>
          <div class="content">{{item.comment}}</div>
          <div class="chapter-wrap" v-if="item.elecseal && !item.pos">
            <div class="chapter" style="position: relative;" v-for="(url,index) in item.elecsealurl" :key="index" @click="handleCheckSeal(item)">
              <img :src="url"/>
              <Spin v-if="item._waiting" fix size="small"></Spin>
            </div>
          </div>
          <div class="chapter-wrap" :class="{'eseal-chapter-wrap': item.pos && signatureType == '3'}" v-else-if="item.elecseal && item.pos">
            <!-- <div :id="item.pos"  class="elecseal-pos" :class="{'can-click-wrap': item.pos && signatureType == '3'}"></div> -->
            <div :id="pos"  class="elecseal-pos chapter" v-for="(pos, index) in item.pos" :key="index"></div>
          </div>
          <div class="time"><label><span style="margin-right: 5px;">{{item.deptName}}</span><span style="margin-right: 10px;">{{item.userName}}</span><span>{{item.endTime}}</span></label></div>
        </div>
      </div>
    </div>
    <!--印章选择Modal-->
    <seal-modal
      ref="sealModal" 
      v-model="elecsealSelectModel"
      :chapterWID="chapterWID"
      :loading="elecsealLoading"
      :elecseal="elecseal"
      :multiple="multiple"
      :needElecseal="needElecseal"
      :needEsignature="needEsignature"
      :clip="clip"
      :esignature="esignature && signatureType == '1'"
      :signatureType="signatureType"
      @on-close="closeModel"
      @on-confirm="onConform"></seal-modal>
    <!-- 默认模式下，印章二次验证 -->
    <second-verification v-model="secondVerModal" @on-pass="onVerifyPass"></second-verification>
    <!--诺安的签章验证弹框 -->
    <check-seal :show.sync="showCheckSeal" :isSuccess="isSuccess" />
  </div>
</template>
<script>
  import api from '@/api/comment'
  import commentMixin from "mixins/emapflow-comment"
  import Clickoutside from "mixins/clickoutside.js"
  import KingGridMixin from 'mixins/kinggrid'
  import SecondVerification from "./features/second-verification"
  import ESeal from 'components/eseal'
  import NuoSeal from 'components/nuo-seal'
  import SealModal from './modals/seal-modal.vue'
  import CheckSeal from "../nuo-seal/checkSeal.vue"
  import 'utils/ESeal'
  export default {
    name: "emap-flow-comment",
    data() {
      return {
        elecsealSelectModel: false,
        validateError: false,
        timer: null,
        showSample: false,
        esealFlowComments: [],
        secondVerModal: false,  // 默认模式下的二次验证dialog
        tempWIDS: [], // chapterWID 临时存储
        tempURLS: [],  // chapterUrl 临时存储,
        showHistory: this.spread,
        historyLoading: false,
        historyEmpty: false,
        showCheckSeal: false,
        isSuccess: false,
        il8Placeholder:this.placeholder === '请输入您的意见' ? this.$LocalH5('vaildComment') : this.placeholder
      }
    },
    props: {
      field: String,
      placeholder: {
        type: String,
        default: '请输入您的意见'
      }
    },
    computed: {
      elecsealClassArr() {
        const arr = []
        if (this.signatureType == '1') {
          if(this.multiple) {
            if (this.chapterUrl.length === 2) {
              arr.push('full')
            }
            if (this.chapterUrl.length == 1) {
              arr.push('single')
            }
          } else {
            arr.push('radio')
            if (this.chapterUrl.length == 1) {
              arr.push('full')
            }
          }
        }
        if (this.signatureType == '2') {
          if (this.multiple) {
            if (this.kingGridWidArr.length === 2) {
              arr.push('full')
            }
            if (this.kingGridWidArr.length == 1 && !this.curOptPos) {
              arr.push('single')
            }
            if (this.kingGridWidArr.length == 1 && this.curOptPos === this.kingGridPosArr[1]) {
              arr.push('single')
            }
            if (this.kingGridWidArr.length == 1 && this.curOptPos === this.kingGridPosArr[0]) {
              arr.push('single-left')
            }
          } else {
            arr.push('radio')
            if (this.kingGridWidArr.length == 1) {
              arr.push('full')
            }
          }
        }
        if (this.readonly) {
          arr.push('readonly')
        }
        return arr
      }
    },
    components: {
      ESeal, SecondVerification, SealModal, NuoSeal, CheckSeal
    },
    directives: { Clickoutside },
    mixins: [commentMixin, KingGridMixin],
    watch: {
      comment: function(newval) {
        if(newval) this.validateError = false;
        this.emitInput()
      },
      chapterWID: function(newVal) {
        this.$emit('inputBlur', {"flowComment":this.comment, "elecsealUrl":newVal, "approval": this.approval_display});
      }
    },
    methods: {
      handleCheckSeal(item, autoCheck) {
        console.log('点击验签', item)
        if (this.signatureType === '4') {
          autoCheck = autoCheck || false
          const _waiting = item._waiting
          if (_waiting) return
          this.$set(item, '_waiting', true)
          this.nuoSeal.checkSign(item, (status, data, base64) => {
            if (status === '0' || status === '1') {
              this.showCheckSeal = true
              this.isSuccess = status === '0' ? true : false
            } else if (status === '3') {
              item.elecsealurl = [base64] // 诺安，目前只有一个
              if(!autoCheck){
                this.showCheckSeal = true
                this.isSuccess = item.sealValid === '0'
              }
            }
            this.$set(item, '_waiting', false)
          }, autoCheck)
        }
      },
      autoCheckAllSign(list) {
        console.log('自动验签')
        if (this.signatureType === '4') {
          list.forEach(item => {
            this.handleCheckSeal(item, true)
          })
        }
      },
      approvalChange(value) {
        if(this.checkboxOnly && this.mergeOptions.length == 1) {
          this.approval_display = !value ? '' : this.mergeOptions[0].name;
          this.$emit('approval-change', value, this.field, this.mergeOptions[0]);
        } else {
          this.validateError = false;
          let option = this.mergeOptions.filter((opt)=>{ return opt.id === value})[0];
          this.approval_display = option.name;
          this.$emit('approval-change', value, this.field, option);
        }
        this.emitInput();
        // inputBlur 兼容易表通
        this.$emit('inputBlur', {"flowComment":this.comment, "elecsealUrl":this.chapterWID, "approval": this.approval_display});
      },
      saveSample() {
        if(!this.comment) return
        api.saveComment({'NAME': this.comment, "DEFKEY": this.defKey}).then(data => {
          if(data.code == '0') {
            this.$Message.success(this.$LocalH5('operateSuccess'));
          } else {
            this.$Message.error(data.msg);
          }
        })
      },
      chooseComment(name) {
        this.comment = name;
      },
      handleHistory() {
        this.showHistory = !this.showHistory;
      },
      // 印章选择
      sealSelect() {
        if (this.getSealLoading || this.readonly) return
        if (this.signatureType == '2') {
          if (this.iskinggrid) {
            let pos
            if (this.multiple) {
              //指定选完章后的渲染位置
              if (!this.kingGridWidArr.length) {
                pos = this.kingGridPosArr[0]
              } else if (this.kingGridWidArr.length ===  1) {
                pos = this.curOptPos ? this.curOptPos : this.kingGridPosArr[1]
              }
            } else {
              pos = this.kingGridPosArr[0]
            }
            this.createKingGridSeal(pos)
          } else {
            console.error('kinggrid属性以及kinggrid.documentid必传!!')
          }
        } else {
          this.elecsealSelectModel = true
        }
      },
      // 阻止已选印章、签名遮罩事件冒泡
      preventEvent(e) {
        e.stopPropagation();
        e.preventDefault();
      },
      // 更改印章、签名
      modifySeal() {
        this.elecsealSelectModel = true;
      },
      // 删除印章、签名
      delSeal(item, index) {
        let wid = item.indexOf('&_=')> -1 ? item.slice(item.indexOf('wid=') + 4, item.indexOf('&_=')) : item.slice(item.indexOf('wid=') + 4);
        let widsStr = this.chapterWID.split(',');
        this.chapterWID = widsStr.filter(item => item!==wid)[0] || '';
        this.chapterUrl.splice(index, 1);
        this.emitInput();
      },
      onConform(wids, urls) {
        this.tempWIDS = wids;
        this.tempURLS = urls;
        // signatureType 如果不为'1'即非默认签章模式，手动签名不允许使用 确认人： 王志伟，修改人：wyj 2021/1/12
        if (this.signatureType == '2') {
          if (this.onOk) {
            this.onOk.call(this.kingGridCon)
          }
        } else if (this.signatureType == '1' && this.sealverify){
          this.secondVerModal = true;
        } else {
          this.onVerifyPass();
        }
      },
      closeModel() {
        if (this.signatureType == '2' && this.dialog && this.dialog.remove) {
          this.dialog.remove()
        }
      },
      // 签章使用验证通过
      onVerifyPass() {
        this.chapterWID = this.tempWIDS.join(',');
        this.chapterUrl = JSON.parse(JSON.stringify(this.tempURLS));
        this.tempWIDS = [];
        this.tempURLS = [];
        this.emitInput();
        this.elecsealSelectModel = false;
      },
      onFocus() {
        if(!this.sample || this.readonly) return;
        let params = {
          "DEFKEY": this.defKey,
          "pageFlag": 1
        }
        api.getCommentSample(params).then(data => {
          if(data.code == '0') {
            this.showSample = true;
            this.defaultComments = data.datas.queryComment.rows;
            this.defaultComments = this.defaultComments.map(row =>{
              row.active = this.comment === row.NAME;
              return row           
            })
          }
        })
      },
      doCloseActive() {
        this.showSample = false;
      },
      onBlur() {
        if(this.readonly) return
        this.$emit('inputBlur', {"flowComment":this.comment, "elecsealUrl":this.chapterWID, "approval": this.approval_display});
      },
      /**
       * 校验说明：校验建议框是否必填
       */
      validate() {
        let result = this.validateDefault();
        if(!result.valid) {
          this.$Message.warning(result.msg);
          if(result.key === 'comment') this.validateError = true;
        }
        return result.valid
      },
      eSealSubmit() {
        this.$refs.eSeal.$children[0].submit();
      }
    },
    beforeDestroy () {
      if(this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      var output = document.getElementById(this.output);
      if (output) output.remove();
    }
  };
</script>
<style>
.emap-flow-comment-item .ivu-spin-fix {
  background-color: rgba(255,255,255,.9) !important;
}
</style>
<style lang="css">
  .emap-flow-comment {
    margin: 5px 10px;
    line-height: 1.5;
  }
  .comment-title {
    padding: 12px 16px 8px 16px;
    font-size: 16px;
    color: #13152D;
    position: relative;
    box-shadow: inset 0 -1px 0 0 #EDF2FB;
  }
  .comment-required::before {
    position: absolute;
    left: 6px;
    color: #ee0a24;
    font-size: 14px;
    content: '*';
  }
  .option-label {
    margin-left: 8px;
  }
  .emap-flow-comment .emap-flow-comment-item {
    border: 1px solid #dcdee2;
  }
  .history-comment-label {
    line-height: 40px;
    cursor: pointer;
    user-select: none;
  }
  .history-icon {
    margin-left: 10px;
  }
  .emap-flow-old-comment .emap-flow-comment-item .kg-img-div .kg-img-icons {
    display: none;
  }
  .emap-flow-comment .emap-flow-comment-item:not(:last-child) {
    border-bottom: none;
  }
  .emap-flow-comment-item {
    position: relative;
    padding: 15px 10px 30px;
  }
  .emap-flow-comment-item.current-comment {
    padding: 2px 0 6px 0;
    border: none;
  }
  .emap-flow-comment-clearfix:after {
    content: '';
    display: table;
    clear: both;
  }
  .emap-flow-comment-view {
    flex: 2;
    max-width: 200px;
    border-right: 1px solid #dddee1;
  }
  .emap-flow-comment-appendix {
    flex: 3;
  }
  .emap-flow-comment-add {
    display: flex;
    height: 50%;
    padding-left: 16px;
    align-items: center;
  }
  .emap-flow-comment-add span {
    text-decoration: underline;
    cursor: pointer;
  }
  .emap-flow-comment-add .added{
    color: #2d8cf0;
  }
  .emap-flow-comment-add .not-added{
    color: #ed4014;
  }
  .emap-flow-comment-item textarea {
    resize: none;
  }
  .emap-flow-comment-item.current-comment .ivu-form-item {
    margin-top: 4px;
    margin-bottom: 0;
  }
  .emap-flow-comment .emap-flow-comment-item .title {
    font-size: 14px;
  }

  .emap-flow-comment .emap-flow-comment-item .time {
    font-size: 14px;
    position: absolute;
    right: 50px;
    bottom: 10px;
    z-index: 2;
  }
  .emap-flow-comment .emap-flow-comment-item .chapter-wrap {
    position: absolute;
    max-height:73px;
    right: 20px;
    bottom: 40px;
    z-index: 1;
  }
  .history-comment-empty {
    text-align: center;
    color: #dddee1;
  }
  .history-comment-loading .ivu-spin-dot {
    display: inline-block;
  }
  .chapter-wrap .chapter {
    display: inline-block;
    width: 73px;
    height: 73px;
    cursor: pointer;
  }
  .emap-flow-comment .emap-flow-comment-item .chapter-wrap.eseal-chapter-wrap {
    max-height: 90px;
    width: 90px;
    bottom: 50%;
    transform: translateY(40%);
  }
  .chapter img {
    display: block;
    max-width: 100px;
    max-height: 73px;
  }
  .emap-flow-comment .emap-flow-comment-item .chapter-wrap.eseal-chapter-wrap img {
    width: 100%;
    height: 100%;
    max-height: 100%;
  }
  .current-comment.hasElecseal .ivu-form-item-content:after {
    align-items: center;
    display: table;
    content: '';
    clear: both;
  }
  .dropdown-input {
    float: left;
    width: 100%;
  }
  .current-comment.hasElecseal .dropdown-input {
    width: calc(100% - 220px);
  }
  .current-comment.hasElecseal.radio .dropdown-input {
    width: calc(100% - 115px);
  }
  .comment-simulator>.ivu-input {
    display: none;
  }
  .comment-simulator>.ivu-input-group-append {
    background: #fff;
    padding: 0;
    max-height: 105px;
    border: 1px solid #dddee1;
  }
  .comment-simulator.comment-input-error>.ivu-input-group-append {
    border-color: #ed4014;
  }
  .comment-simulator.comment-input-readonly >.ivu-input-group-append:hover {
    border-color: #dcdee2;
    box-shadow: none;
  }
  .comment-simulator>.ivu-input-group-append:hover {
    border-color: #57a3f3;
    box-shadow: 0 0 0 2px rgba(45,140,240,.2);
  }
  .comment-wrapper {
    overflow: auto;
    height: 103px;
  }
  .comment-textarea textarea:focus {
    box-shadow: none;
  } 
  .comment-textarea textarea {
    border: none;
    min-height: 73px;
  }
  .comment-toolbar {
    line-height: 20px;
    padding: 0 10px 10px 10px;
    text-align: right;
  }
  .comment-sample-save {
    font-size: 14px;
    color: #3097F3;
    cursor: pointer;
    user-select: none;
  }
  .emap-flow-comment-elecseal {
    position: relative;
    float: left;
    margin-left: 10px;
    border: 1px solid #dddee1;
    border-radius: 4px;
    height: 105px;
    /* width: 210px; */
    cursor:pointer;
  }
  .emap-flow-comment-elecseal.radio {
    width: 105px;
  }
  .emap-flow-comment-elecseal [class^="king-grid-pos"] {
    position: absolute;
    top: 0;
    bottom: 0;
  }
  .emap-flow-comment-elecseal .king-grid-pos-1 {
    left: 0;
    right: 50%;
  }
  .emap-flow-comment-elecseal .king-grid-pos-1.radio {
    left: 0;
    right: 0;
  }
  .emap-flow-comment-elecseal .king-grid-pos-2 {
    left: 50%;
    right: 0;
  }
  .emap-flow-comment-elecseal.e-signature-wrap {
    border: 0 none;
  }
  .emap-flow-comment-elecseal.e-signature-wrap:before, .emap-flow-comment-elecseal.e-signature-wrap:after {
    display: none;
  }
  .emap-flow-comment-elecseal.readonly {
    cursor: not-allowed;
  }
  .emap-flow-comment-elecseal.readonly .kg-img-div .kg-img-icons{
    display: none;
  }
  .emap-flow-comment-elecseal.full:before, .emap-flow-comment-elecseal.full:after {
    visibility: hidden;
  }
  .emap-flow-comment-elecseal.single:before {
    left: 146px;
  }
  .emap-flow-comment-elecseal.single:after {
    left: 155px;
  }
  .emap-flow-elecseal-label.single {
    left: 128px;
  }
  .emap-flow-comment-elecseal.radio:before {
    left: 41.5px;
  }
  .emap-flow-comment-elecseal.radio:after {
    left: 50.5px;
  }
  .emap-flow-elecseal-label.radio {
    left: 23.5px;
  }
  .emap-flow-comment-elecseal.single-left::before  {
    left: 35px;
  }
  .emap-flow-comment-elecseal.single-left:after {
    left: 44px;
  }
  .emap-flow-elecseal-label.single-left {
    left: 20px;
  }
  .emap-flow-comment-elecseal:before {
    position: absolute;
    top: 41px;
    left: 94px;
    content: "";
    display: block;
    width: 20px;
    height: 2px;
    background: #dddee1;
  }
  .emap-flow-elecseal-imgs {
    display: table;
    max-width: 100%;
    height: 102px;
  }
  .emap-flow-elecseal-img {
    position: relative;
    display: table-cell;
    vertical-align: middle;
    height: 102px;
    width: 104px;
  }
  .img-popup-body {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
    text-align: center;
    background: rgba(0, 0, 0, .5);
  }
  .emap-flow-elecseal-img:hover .img-popup-body {
    display: block;
  }
  .img-popup-body>button {
    margin-top: 35px;
    padding: 5px;
  }
  .emap-flow-elecseal-img>img{
    display: block;
    max-height: 100%;
    max-width: 100%;
    margin: auto;
  }
  .emap-flow-comment-elecseal:after {
    position: absolute;
    top: 32px;
    left: 103px;
    content: "";
    display: block;
    width: 2px;
    height: 20px;
    background: #dddee1;
  }
  .emap-flow-elecseal-label {
    position: absolute;
    left: 77px;
    top: 48px;
    color: #dddee1;
    user-select: none;
  }
  .comment-sample-save.disabled {
    opacity: 0.5;
  }
  .emap-flow-comment-opt .kg-img-div.kg-default,.emap-flow-comment-opt .kg-img-div.kg-default img{
    width: 105px !important;
    height: 105px!important;
  }
  .emap-flow-old-comment .kg-img-div.kg-default,.emap-flow-old-comment .kg-img-div.kg-default img{
    width: 73px !important;
    height: 73px!important;
  }
  .clone-kg-img-div.kg-img-div.kg-img-div.kg-default, .clone-kg-img-div.can-click-wrap{
    position: fixed;
    top: 100px !important;
    left: 500px !important;
  }
  .clone-kg-img-div.can-click-wrap, .clone-kg-img-div.can-click-wrap img {
    width: 250px;
    height: 250px;
  }
  .clone-kg-img-div.kg-img-div.kg-img-div.kg-default, .clone-kg-img-div.kg-img-div.kg-img-div.kg-default img {
    width: 250px !important;
    height: 250px !important;
    z-index: -1;
  }
  .clone-kg-img-div.kg-img-div.kg-img-div.kg-default .kg-invalid {
    top: 100px !important;
  }
  .clone-kg-img-div.kg-img-div.kg-img-div.kg-default .kg-invalid .kg-invalid-item {
    height: 25px !important;
  }
  .clone-kg-img-div.kg-img-div.kg-img-div.kg-default .kg-invalid .kg-invalid-item:first-child + div {
    height: 25px !important;
  }
  .i-addDate,.kg-pwd {
    display: none;
  }
  .kg-dialog .form-control {
    padding: 6px 5px;
  }
  .elecseal-pos {
    width: 73px;
    height: 73px;
    margin-left: auto;
  }
  .elecseal-pos.can-click-wrap {
    width: 90px;
    height: 90px;
    cursor: pointer;
  }
  .e-signature-wrap .seal-container {
    width: 105px;
    height: 105px;
  }
  .e-signature-wrap .seal_choosed, .e-signature-wrap .seal {
    width: 100%;
    height: 100%;
  }
  .e-signature-wrap .seal_choosed .sealImg {
    height: 100%;
    width: 100%;
  }
  .e-signature-wrap .sealDeleteButton {
    width: auto;
    left: 0;
    right: 0;
    bottom: 0;
    height: 20px;
  }
  .e-signature-wrap .seal .sealIcon {
    margin-top: 16px;
  }
  .e-signature-wrap .code-button {
    top: auto;
    bottom: 0;
  }
  .e-signature-wrap .seal-modal, .e-signature-wrap .sealDialog, .e-signature-wrap .seal-dialog{
    z-index: 1001;
  }
  .emap-flow-comment .emap-flow-comment-item .content {
    text-indent: 2em;
    font-size: 14px;
    margin: 10px 0;
    min-height: 60px;
    margin-right: 220px;
    word-break: break-all;
  }
</style>